export function getCookie(cname): string {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function splitCookieForGTM(gaCookie: string | boolean): string {
  if (typeof gaCookie === 'boolean') {
    return '';
  } else {
    let splitCookie = gaCookie.split('.');
    return `${splitCookie[2]}.${splitCookie[3]}`;
  }
}
